import { useContext } from 'react'
import styled from 'styled-components'
import Color from '../../source-editor/caption/style-options/color'
import Font from '../../source-editor/caption/style-options/font'
import Size from '../../source-editor/caption/style-options/size'
import Stroke from '../../source-editor/caption/style-options/stroke'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'

const Container = styled.div`
    display: flex;
    > div {
        margin-right: 10px;
    }
    > div:last-child {
        margin-right: 0;
    }
`

const CreationCaptureCaptionStyleDropdownField = () => {
    const { captionStyle, setCaptionStyle, font } = useContext(CreationCaptureInfoContext)

    return (
        <Container>
            <Font captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} customFontUrl={font?.font} />
            <Size captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} />
            <Color captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} />
            <Stroke captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} />
        </Container>
    )
}

export default CreationCaptureCaptionStyleDropdownField
